"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_v__kids(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_x5F_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 192",
    style: {
      enableBackground: "new 0 0 192 192"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#EBEBEB;}\n\t.st2{opacity:6.000000e-02;}\n\t.st3{fill:#4A4D4E;}\n\t.st4{opacity:0.2;fill:url(#b2ca7fa1-619f-45ca-903c-57092e202b64_2_);enable-background:new    ;}\n\t.st5{fill:#E60000;}\n"), /*#__PURE__*/React.createElement("g", {
    id: "Apps_x5F_ic_x5F_hi"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st0",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 128,
    cy: 80.3,
    r: 24.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128,103.1c-13.4,0-24.3-10.6-24.8-23.8c0,0.3,0,0.7,0,1c0,13.7,11.1,24.8,24.8,24.8s24.8-11.1,24.8-24.8 c0-0.3,0-0.7,0-1C152.3,92.5,141.4,103.1,128,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2ca7fa1-619f-45ca-903c-57092e202b64_1_",
    className: "st1",
    d: "M161.8,151c4.2-0.9,6.9-5,6-9.2c0-0.1-0.1-0.3-0.1-0.4 c-6.3-24.7-22.9-36.3-39.5-36.3s-33.6,11.5-39.9,36.3c-1.1,4.2,1.4,8.4,5.6,9.5c0.1,0,0.3,0.1,0.4,0.1c11.1,2.3,22.5,3.5,33.8,3.5 C139.4,154.5,150.7,153.3,161.8,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.8,149c-11.1,2.3-22.3,3.5-33.6,3.5c-11.4,0-22.7-1.2-33.8-3.5c-0.1,0-0.3-0.1-0.4-0.1 c-3.2-0.8-5.3-3.5-5.7-6.5c-0.5,3.8,1.9,7.5,5.7,8.5c0.1,0,0.3,0.1,0.4,0.1c11.1,2.3,22.5,3.5,33.8,3.5c11.3,0,22.6-1.2,33.6-3.5 c4-0.8,6.7-4.6,6.1-8.6C167.5,145.6,165.1,148.3,161.8,149z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.3,74.3c-1-9.8-7.2-17.9-15.6-21.8c1.6-2.3,4.5-5.3,9.7-7.3c2.1-0.8,3.1-3.2,2.3-5.2 c-0.8-2.1-3.2-3.1-5.2-2.3c-5.9,2.3-9.8,5.7-12.2,8.7c-3.9-4.7-9-5.8-9.3-5.9c-2.2-0.5-4.3,0.9-4.8,3.1c-0.5,2.2,0.9,4.3,3.1,4.8 c0,0,1.5,0.4,3.2,1.7c-13.4,0.9-24.4,11.6-25.4,25.1c-0.1,1.1,0.3,2.2,1.1,3.1c0.8,0.8,1.8,1.3,2.9,1.3c0,0,0,0,0,0l19.2,0 c1.4,0,2.7-0.7,3.4-1.9l3.3-5.2l3.3,5.2c0.7,1.2,2,1.9,3.4,1.9h13.6c2.2,0,4-1.8,4-4v-0.7C155.3,74.5,155.3,74.4,155.3,74.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 64,
    cy: 80.3,
    r: 24.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2ca7fa1-619f-45ca-903c-57092e202b64",
    className: "st1",
    d: "M97.7,151c4.2-0.9,6.9-5,6-9.2c0-0.1-0.1-0.3-0.1-0.4 c-6.3-24.7-22.9-36.3-39.5-36.3s-33.6,11.5-39.9,36.3c-1.1,4.2,1.4,8.4,5.6,9.5c0.1,0,0.3,0.1,0.4,0.1c11.1,2.3,22.5,3.5,33.8,3.5 C75.4,154.5,86.6,153.3,97.7,151z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,103.1c-13.4,0-24.3-10.6-24.8-23.8c0,0.3,0,0.7,0,1c0,13.7,11.1,24.8,24.8,24.8S88.8,94,88.8,80.3 c0-0.3,0-0.7,0-1C88.2,92.5,77.4,103.1,64,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.7,149c-11.1,2.3-22.3,3.5-33.6,3.5c-11.4,0-22.7-1.2-33.8-3.5c-0.1,0-0.3-0.1-0.4-0.1 c-3.2-0.8-5.3-3.5-5.7-6.5c-0.5,3.8,1.9,7.5,5.7,8.5c0.1,0,0.3,0.1,0.4,0.1c11.1,2.3,22.5,3.5,33.8,3.5c11.3,0,22.6-1.2,33.6-3.5 c4-0.8,6.7-4.6,6.1-8.6C103.4,145.6,101,148.3,97.7,149z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2ca7fa1-619f-45ca-903c-57092e202b64_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.6462,
    y1: 136.0931,
    x2: 128.4828,
    y2: 136.0931
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "b2ca7fa1-619f-45ca-903c-57092e202b64_4_",
    className: "st4",
    d: "M128.2,154.5c-10.8,0-21.6-1-32.1-3.1v0 c0.6-0.1,1.1-0.2,1.7-0.3c4.2-0.9,6.9-5,6-9.2c0-0.1-0.1-0.3-0.1-0.4c-2.5-10-6.8-17.9-12.1-23.7l0,0l36.8,36.8l0,0L128.2,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M91,78.7C90.6,63.7,78.5,52,63.6,52c-8.6,0-16.5,3.9-21.7,10.6l-8.8-2.4c-2.2-0.6-4.4,0.7-5,2.9 c-0.6,2.2,0.7,4.4,2.9,5L85.9,83c0.4,0.1,0.7,0.1,1.1,0.1c1.8,0,3.4-1.2,3.9-3C91,79.6,91,79.1,91,78.7L91,78.7z"
  })));
}

var _default = ic_v__kids;
exports.default = _default;